// What the catalog editor tells its page after an editor change. Clicking, selecting and scrolling all fire one, and
// the stored text is often not in the form the editor writes (trailing blank lines, anything saved before a
// formatting change), so reporting every change made an untouched answer look edited and lit up Save.

import { withoutImageSizes } from './catalogImages';

export interface ChangeBaseline {
  /** The text the answer was loaded with. */
  loaded: string;
  /** The same content as this editor writes it. */
  loadedAsSaved: string;
  /** What was last reported, as this editor writes it. */
  lastReported: string;
}

/**
 * The text to report, or null when nothing that would be saved has changed. Content back to what was loaded is
 * reported as the loaded text itself, so an edit that is undone stops counting as one.
 */
export const changeToReport = (markdown: string, baseline: ChangeBaseline): string | null => {
  // A picture's size is learned only once the editor draws it, so it can appear without anyone changing anything.
  const content = withoutImageSizes(markdown);
  if (content === withoutImageSizes(baseline.lastReported)) return null;
  return content === withoutImageSizes(baseline.loadedAsSaved) ? baseline.loaded : markdown;
};
